export default function SingleBanner({ imageUrl }) {
    return (
        <>
            {
                imageUrl
                    ? <section className="dealership-hero position-relative overflow-hidden">
                        <div className="dl-hero-single">
                            <div className="at_hero_slider">
                                <div className="at-hero-banner">
                                    <img src={imageUrl} alt="banner" className="at_hero_car" />
                                </div>
                            </div>
                        </div>
                    </section>
                    : null
            }
        </>
    );
}